import { automationFullFragment } from './fragments';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationDuplicateAtom = createMutationAtomFactory(
  'automations.duplicate',
  (params: { id: string }) => ({
    automationsAutomationDuplicate: {
      __args: {
        id: params.id,
      },
      ...automationFullFragment,
    },
  }),
);
